import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const ToastContext = createContext();

export const useToast = () => {
    return useContext(ToastContext);
};

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState(null);

    const showToast = useCallback((msg, type = 'success') => {
        setToast({ msg, type });
    }, []);

    useEffect(() => {
        if (toast) {
            const timer = setTimeout(() => {
                setToast(null);
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [toast]);

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            {/* Global Toast UI - Bottom Center, Uber Theme */}
            {toast && (
                <div className="fixed bottom-24 left-1/2 -translate-x-1/2 z-[999999] flex items-center justify-center animate-fade-in-up">
                    <div className={`px-6 py-3 rounded-full shadow-[0_20px_40px_-15px_rgba(0,0,0,0.3)] flex items-center gap-3 backdrop-blur-2xl transition-all ${
                        toast.type === 'error' 
                            ? 'bg-red-600/95 text-white border border-red-500/50' 
                            : 'bg-black/95 text-white border border-gray-800/50'
                    }`}>
                        {toast.type === 'error' ? (
                            <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        ) : (
                            <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                            </svg>
                        )}
                        <span className="text-[13px] font-bold tracking-wide">
                            {toast.msg}
                        </span>
                    </div>
                </div>
            )}
        </ToastContext.Provider>
    );
};
